import StartMap from "./startMap";

export default StartMap;
